import {ConfirmationDialog} from "../components/ConfirmationDialog";
import React, {useCallback, useEffect, useState} from "react";
import {useAuth} from "../auth/AuthHook";
import {useErrorReporter} from "../general/ErrorViewer";
import {withBase} from "../utils/basePath";
import {useTranslation} from "react-i18next";

interface AboutBoxProps {
    isOpen: boolean;
    onClose: () => void;
}

export function AboutBox({isOpen, onClose}: AboutBoxProps) {
    const [releaseInfo, setReleaseInfo] = useState("")
    const {isLoggedIn, getHeaders} = useAuth();
    const reporter = useErrorReporter()
    const {t} = useTranslation()
    const fetchBuildInfo = useCallback(async () => {
        try {
            if (isLoggedIn()) {
                const resp = await fetch(withBase("api/server/build_info/"), {
                    headers: {
                        ...await getHeaders(),
                        "Content-Type": "application/json",
                    },
                })
                if (!resp.ok) {
                    reporter(`Error received while fetching build info: ${resp.status} - ${await resp.text()}`)
                    return
                }
                const id_resp = await resp.json();
                const rel = id_resp["release"]
                if (rel != undefined) {
                    setReleaseInfo(rel)
                }
            } else {
                setReleaseInfo("")
            }
        } catch (e) {
            reporter(`Cannot get build info: ${e}`);
        }
    }, [isLoggedIn, getHeaders, reporter])

    useEffect(() => {
        fetchBuildInfo();
    }, [fetchBuildInfo]);

    return (
        <ConfirmationDialog
            isOpen={isOpen}
            onClose={onClose}
            content={
                <div className="flex flex-col gap-4">
                    <h2 className="text-xl font-bold">About Arten.ai</h2>
                    <p>Arten.ai is an AI based Technical Support Assistant, developed by <a href="https://enoventum.com/" className="text-blue-400 underline">Enoventum Labs Ltd</a></p>
                    <div> version: {releaseInfo}</div>
                </div>
            }
            cancelButton={<></>}
            submitButton={
                <button
                    className="px-4 py-2 text-sm font-medium rounded-md "
                    onClick={onClose}
                >
                    {t("Ok")}
                </button>
            }
        />
    )
}